import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { UserContext } from "@app/contexts";

export const notConnectedGuard = (userContext: UserContext = inject(UserContext), router: Router = inject(Router)): boolean => {
  if (userContext.isConnected) {
    router.navigate(['/']);
    return false;
  }

  return true;
}
